var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.lineas.length > 1,
              expression: "lineas.length > 1"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c("div", { staticClass: "form-field select2" }, [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    options: _vm.lineas,
                    label: "name",
                    id: "linea",
                    placeholder: "Seleccione..."
                  },
                  on: { input: _vm.inputLinea },
                  model: {
                    value: _vm.selectedLinea,
                    callback: function($$v) {
                      _vm.selectedLinea = $$v
                    },
                    expression: "selectedLinea"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "linea" } }, [_vm._v("Línea")]),
                _vm._v(" "),
                _vm.errores.linea_id
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.linea_id[0]))])]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("date-picker", {
                attrs: { type: "date", id: "date_booking" },
                model: {
                  value: _vm.form.date_booking,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "date_booking", $$v)
                  },
                  expression: "form.date_booking"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("F. Booking")]),
              _vm._v(" "),
              _vm.errores.date_booking
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.date_booking[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          {
            staticClass: "form-field select2",
            class: {
              "select2--disabled": _vm.tipoFormulario !== "N"
            }
          },
          [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    taggable: "",
                    options: _vm.exportadores,
                    id: "exportador",
                    placeholder: "Seleccione..."
                  },
                  model: {
                    value: _vm.form.exportador,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "exportador", $$v)
                    },
                    expression: "form.exportador"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "exportador" } }, [
                  _vm._v("Exportador")
                ]),
                _vm._v(" "),
                _vm.errores.exportador
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.exportador[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  readonly: _vm.tipoFormulario !== "N",
                  id: "booking",
                  placeholder: "# Booking"
                },
                model: {
                  value: _vm.form.booking,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "booking", $$v)
                  },
                  expression: "form.booking"
                }
              },
              [
                _c("span", [_vm._v("Booking")]),
                _vm._v(" "),
                _vm.errores.booking
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.booking[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "booking_count", placeholder: "#######" },
                model: {
                  value: _vm.form.booking_count,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "booking_count", $$v)
                  },
                  expression: "form.booking_count"
                }
              },
              [
                _c("span", [_vm._v("Booking count")]),
                _vm._v(" "),
                _vm.errores.booking_count
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.booking_count[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "vessel", placeholder: "###" },
                model: {
                  value: _vm.form.vessel,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "vessel", $$v)
                  },
                  expression: "form.vessel"
                }
              },
              [
                _c("span", [_vm._v("Vessel")]),
                _vm._v(" "),
                _vm.errores.vessel
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.vessel[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "voyage", placeholder: "###" },
                model: {
                  value: _vm.form.voyage,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "voyage", $$v)
                  },
                  expression: "form.voyage"
                }
              },
              [
                _c("span", [_vm._v("Voyage")]),
                _vm._v(" "),
                _vm.errores.voyage
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.voyage[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "temperature", placeholder: "###" },
                model: {
                  value: _vm.form.temperature,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "temperature", $$v)
                  },
                  expression: "form.temperature"
                }
              },
              [
                _c("span", [_vm._v("Temperatura")]),
                _vm._v(" "),
                _vm.errores.temperature
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.temperature[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "ventilation", placeholder: "###" },
                model: {
                  value: _vm.form.ventilation,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "ventilation", $$v)
                  },
                  expression: "form.ventilation"
                }
              },
              [
                _c("span", [_vm._v("Ventilación")]),
                _vm._v(" "),
                _vm.errores.ventilation
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.ventilation[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  label: "address",
                  options: _vm.yards,
                  id: "yard_code",
                  placeholder: "Seleccione..."
                },
                on: { input: _vm.inputYard },
                model: {
                  value: _vm.selectedYard,
                  callback: function($$v) {
                    _vm.selectedYard = $$v
                  },
                  expression: "selectedYard"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "yard_code" } }, [_vm._v("Patio")]),
              _vm._v(" "),
              _vm.errores.yard_code
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.yard_code[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.size_container,
                      expression: "form.size_container"
                    }
                  ],
                  attrs: {
                    disabled: _vm.tipoFormulario !== "N",
                    name: "size_container",
                    id: "size_container"
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "size_container",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "40" } }, [_vm._v("40")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "20" } }, [_vm._v("20")])
                ]
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "tipo_contenedor" } }, [
                _vm._v("T. Contenedor")
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    options: _vm.tiposContenedor,
                    label: "descripcion",
                    id: "tipo_contenedor",
                    placeholder: "Seleccione..."
                  },
                  on: { input: _vm.inputType },
                  model: {
                    value: _vm.selectedType,
                    callback: function($$v) {
                      _vm.selectedType = $$v
                    },
                    expression: "selectedType"
                  }
                }),
                _vm._v(" "),
                _vm.errores.type
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.type[0]))])]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "remark", placeholder: "#######" },
                model: {
                  value: _vm.form.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark"
                }
              },
              [
                _c("span", [_vm._v("Remark")]),
                _vm._v(" "),
                _vm.errores.remark
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.remark[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "location_receipt", placeholder: "#######" },
                model: {
                  value: _vm.form.location_receipt,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "location_receipt", $$v)
                  },
                  expression: "form.location_receipt"
                }
              },
              [
                _c("span", [_vm._v("Localización")]),
                _vm._v(" "),
                _vm.errores.location_receipt
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.location_receipt[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "marca", placeholder: "#######" },
                model: {
                  value: _vm.form.marca,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "marca", $$v)
                  },
                  expression: "form.marca"
                }
              },
              [
                _c("span", [_vm._v("Marca")]),
                _vm._v(" "),
                _vm.errores.marca
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.marca[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "oxigeno", placeholder: "#######" },
                model: {
                  value: _vm.form.oxigeno,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "oxigeno", $$v)
                  },
                  expression: "form.oxigeno"
                }
              },
              [
                _c("span", [_vm._v("Oxígeno")]),
                _vm._v(" "),
                _vm.errores.oxigeno
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.oxigeno[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "dioxido_carbono", placeholder: "#######" },
                model: {
                  value: _vm.form.dioxido_carbono,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "dioxido_carbono", $$v)
                  },
                  expression: "form.dioxido_carbono"
                }
              },
              [
                _c("span", [_vm._v("Dióxido de carbono")]),
                _vm._v(" "),
                _vm.errores.dioxido_carbono
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.dioxido_carbono[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.guardar }
        },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _vm._v(" "),
          _c("span", [_vm._v("Guardar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cancelar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Coparn")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57e02529", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e02529","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/ecas-coparn/Coparn.vue
// module id = 427
// module chunks = 0